import { ActionType } from "typesafe-actions";
import * as actions from "./commonActions";

export type AppActions = ActionType<typeof actions>;

export const initialState: any = {};

function reducer(state = initialState, action: AppActions) {
  switch (action.type) {
    case actions.track.SUCCESS:
      return {
        ...state,
        ...action.payload
      };
    default:
      return state;
  }
}

export default reducer;
